import CustomEvent from "custom-event";

import ExternalLogger from "../../../../logger/ExternalLogger";

/**
 *  Deprecated Feb. 17, 2021 - Please make updates in react version
 *
 */

const AccountSwitchController = function (
    $scope,
    $rootScope,
    $window,
    $cookies,
    $location,
    $modalInstance,
    accountService,
    LanguageCodeFactory,
    AuthenticationStatusService,
    AccuCodeService,
    paeService,
    accountDetailsFactory
) {
    const vm = this;
    vm.updatePlanCheckbox;
    vm.checkboxValue = "N";
    const logger = ExternalLogger.getInstance("AccountSwitchController");

    $scope.currentDomain = $location.protocol() + "://" + $location.host();
    if ($window.location.port !== "") {
        $scope.currentDomain += ":" + $window.location.port;
    }

    $scope.currentAccount = $scope.currentAccount
        ? $scope.currentAccount
        : accountService.currentAccount;
    $scope.clickedAccount = $scope.clickedAccount
        ? $scope.clickedAccount
        : accountService.clickedAccount;
    $scope.defaultGroupId = $scope.defaultGroupId
        ? $scope.defaultGroupId
        : accountService.defaultGroupId;

    $scope.isEmulator = false;
    if ($scope.defaultGroupId && $scope.defaultGroupId == $scope.clickedAccount.groupId) {
        $scope.isEmulator = true;
    }
    $scope.isEmulatorCallLoaded = false;
    $scope.isContinueCalled = false;
    $scope.displayPage = true;

    $scope.currentDomain += "/";

    $scope.hasSameIndId = false;

    $scope.$on("modal.closing", function (event, reason, closed) {
        if ($scope.isContinueCalled) {
            event.preventDefault();
        }
    });

    vm.cancelSwitchPlan = function () {
        $scope.displayPage = false;
        $rootScope.$broadcast("cancelSwitchPlan");
        $modalInstance.close();
    };

    vm.checkdefaultPlan = function () {
        if (vm.updatePlanCheckbox) {
            vm.checkboxValue = "Y";
        } else {
            vm.checkboxValue = "N";
        }
    };

    vm.getCurrentLanguageSite = function () {
        const currentUrl = $window.location.href;
        const https = "https://";
        const http = "http://";
        const spnLangCode = "es";
        let retLanguageSite = "ENG";
        if (
            currentUrl.indexOf(https + spnLangCode) >= 0 ||
            currentUrl.indexOf(http + spnLangCode) >= 0
        ) {
            retLanguageSite = "SPN";
        }
        return retLanguageSite;
    };

    const updateAccu = function (val) {
        if (val) {
            $rootScope.css.accu = val;
        } else {
            $rootScope.css.accu = $window.accu;
        }
    };

    vm.continueSwitchPlan = function (account) {
        const customEvt = new CustomEvent("set-active-account", { detail: { account } });
        window.dispatchEvent(customEvt);

        const req = {
            individualId: account.individualId,
            dbName: "NONE",
            accuCode: account.accuCode,
            updateDefault: vm.checkboxValue,
            gaId: account.groupId
        };

        $scope.isContinueCalled = true;

        const clickedAccountParams = {
            groupId: $scope.clickedAccount.groupId,
            individualId: $scope.clickedAccount.individualId,
            dbName: $scope.clickedAccount.dbName
        };

        accountDetailsFactory.accountDetails.query(
            clickedAccountParams,
            function (clickedAccountDetails) {
                accountService.updateDefaultPlan(req).then(function (response) {
                    const method = "AccountSwitchController updateDefaultPlan";
                    let newAccuCode = account.accuCode;
                    if (response.primaryPlan && response.primaryPlan.accuCode) {
                        newAccuCode = response.primaryPlan.accuCode;
                    }
                    if (
                        newAccuCode &&
                        $window.accu !== newAccuCode &&
                        $window.supportedACCU.folders.indexOf(newAccuCode) >= 0
                    ) {
                        logger.error(
                            "{0} - Empower Restricted authentication..changing accu to [{1}]",
                            [method, newAccuCode]
                        );
                        $window.accu = newAccuCode;
                        //update tomcat
                        logger.error("{0} - updating accu...", [method]);
                        //set cookie
                        $cookies.remove("accu", { path: "/" });
                        $cookies.put("accu", $window.accu, { path: "/" });

                        $cookies.remove("accu", { path: "/participant" });
                        $cookies.put("accu", $window.accu, { path: "/participant" });

                        $cookies.remove("clientAccu", { path: "/" });
                        $cookies.put("clientAccu", $window.accu, { path: "/" });

                        $cookies.remove("clientAccu", { path: "/participant" });
                        $cookies.put("clientAccu", $window.accu, { path: "/participant" });

                        $scope.accu = AccuCodeService.getAccuCode();

                        updateAccu($scope.accu);
                    }

                    let nextgenDest = response.destinationUrl;
                    // If the user is on AOD / my contributions etc, they should be taken to AOD for the primary plan for their new context
                    const participantAccountsPage =
                        $window.location.pathname === "/participant/accounts/";
                    if (nextgenDest.indexOf("liatLanding") >= 0) {
                        if (participantAccountsPage) {
                            nextgenDest = clickedAccountDetails.isRetail
                                ? "participant/home/#/dashboard/retirement-income"
                                : `participant/accounts/#/account/${response.primaryPlan.indId}/${response.primaryPlan.gaId}/account-details`;
                        } else {
                            nextgenDest = `participant/home/#/dashboard/retirement-income`;
                        }
                    } else if (nextgenDest.indexOf("enroll") >= 0) {
                    }

                    const lanauageCode = response.languageCode;
                    const currentLanguageSite = vm.getCurrentLanguageSite();
                    try {
                        if (lanauageCode && lanauageCode !== currentLanguageSite) {
                            vm.redirectToPreferredLanguageSite(nextgenDest, lanauageCode, req);
                        } else {
                            vm.switchRedirect(nextgenDest);
                        }
                    } catch (err) {
                        logger.error("Failed to redirect to language site", err);
                        vm.switchRedirect(nextgenDest);
                    }
                });
            }
        );

        // end of continue
    };

    function delayedWindowReload(time = 100) {
        setTimeout(function () {
            $window.location.reload(true);
        }, time);
    }

    vm.switchRedirect = function (nextgenDest) {
        vm.continueEnd();
        const locationPriorToRedirect = $window.location.href;
        const redirectDest = $scope.currentDomain + nextgenDest;
        if (
            $window.location.href === redirectDest ||
            locationPriorToRedirect.indexOf("plan-balances") >= 0 ||
            locationPriorToRedirect.indexOf("other-assets") >= 0
        ) {
            delayedWindowReload(100);
        } else if (
            locationPriorToRedirect.indexOf("enroll") >= 0 &&
            redirectDest.indexOf("enroll") >= 0
        ) {
            $window.location.href = redirectDest;
            delayedWindowReload(100);
        } else if (redirectDest.indexOf("account-details") >= 0) {
            $window.location.href = redirectDest;
            delayedWindowReload(100);
        } else {
            logger.error("Updating window.location - {0}", [redirectDest]);
            $window.location.href = redirectDest;
            if (
                locationPriorToRedirect.indexOf("accounts") >= 0 &&
                redirectDest.indexOf("overview") >= 0
            ) {
                delayedWindowReload(100);
            }
        }
    };

    vm.redirectToPreferredLanguageSite = function (nextgenDest, selectedLanguage, req) {
        const currentUrl = $window.location.href;
        const https = "https://";
        const http = "http://";
        const period = ".";
        const toLangCode = "es";
        let newUrl = currentUrl;
        let idx = currentUrl.indexOf("participant/");
        if (idx < 0) {
            idx = currentUrl.indexOf($window.location.pathname);
        }
        if (idx >= 0) {
            const newOrigin = currentUrl.substr(0, idx);
            console.log("newOrigin:", newOrigin);
            if (selectedLanguage === "SPN") {
                // prepend domain part for the url with language code
                // E.g. https://proj9.retirementpartner.com/participant/home/#/dashboard/retirement-income
                // Will be changed to
                // https://es.proj9.retirementpartner.com/participant/home/#/dashboard/retirement-income
                if (
                    newOrigin.indexOf(https + toLangCode) < 0 &&
                    newOrigin.indexOf(http + toLangCode) < 0
                ) {
                    newUrl = newOrigin.replace(https, https + toLangCode + period);
                    newUrl = newUrl.replace(http, http + toLangCode + period);
                }
                AuthenticationStatusService.clearSpanishLanguageCookies().then(
                    function (data) {
                        LanguageCodeFactory.setLanguageCookies.query(
                            {},
                            function (data) {
                                vm.continueEnd();
                                console.log("Cloned cookies for Spanish site", data);

                                $window.location.href = vm.updateQueryStringParameter(
                                    newUrl + nextgenDest
                                );
                            },
                            function (error) {
                                logger.error("Failed to clone the cookie for Spanish site", error);
                                vm.switchRedirect(nextgenDest);
                            }
                        );
                    },
                    function (error) {
                        logger.error("Failed to clear Spanish site cookie", error);
                        vm.switchRedirect(nextgenDest);
                    }
                );
            } else {
                newUrl = newOrigin.replace(https + toLangCode + period, https);
                newUrl = newUrl.replace(http + toLangCode + period, http);
                accountService.updateEngDefaultPlan(req).then(function (response) {
                    const method = "AccountSwitchController updateEngDefaultPlan";
                    logger.error("{0} - redirect to {1}", [method, nextgenDest]);
                    AuthenticationStatusService.setAccuCodeCookies().then(
                        function (data) {
                            vm.continueEnd();

                            $window.location.href = vm.updateQueryStringParameter(
                                newUrl + nextgenDest
                            );
                        },
                        function (error) {
                            logger.error("Failed to add accuCode language cookie", error);
                            vm.switchRedirect(nextgenDest);
                        }
                    );
                });
            }
        } else {
            console.log("Failed to get current site origin", currentUrl);
            vm.switchRedirect(nextgenDest);
        }
    };

    vm.updateQueryStringParameter = function (uri) {
        const key = "accu";
        const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        const separator = uri.indexOf("?") !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, "$1" + key + "=" + $window.accu + "$2");
        } else {
            return uri + separator + key + "=" + $window.accu;
        }
    };

    /**
     *  After all calls complete, stop the loader and close modal
     */
    vm.continueEnd = () => {
        $scope.isContinueCalled = false;
        $scope.displayPage = false;
        $modalInstance.close();
    };

    vm.isSameIndId = function () {
        if ($scope.currentAccount.individualId === $scope.clickedAccount.individualId) {
            $scope.hasSameIndId = true;
            vm.continueSwitchPlan($scope.clickedAccount);
        }
    };

    vm.init = function () {
        if (!$scope.isEmulator) {
            paeService.checkPaeUser().then(
                function (response) {
                    if (response) {
                        $scope.isEmulator = response.partnerSSOResponse;
                        $scope.isEmulatorCallLoaded = true;
                    }
                },
                function (err) {
                    logger.error("PAE user check failed: ");
                }
            );
        } else {
            $scope.isEmulatorCallLoaded = true;
        }
        vm.isSameIndId();
    };
    vm.init();
};

AccountSwitchController.$inject = [
    "$scope",
    "$rootScope",
    "$window",
    "$cookies",
    "$location",
    "$modalInstance",
    "accountService",
    "LanguageCodeFactory",
    "AuthenticationStatusService",
    "AccuCodeService",
    "paeService",
    "accountDetailsFactory"
];

export default AccountSwitchController;
